import { render, staticRenderFns } from "./Constelacion.vue?vue&type=template&id=f33b6506"
import script from "./Constelacion.vue?vue&type=script&lang=js"
export * from "./Constelacion.vue?vue&type=script&lang=js"
import style0 from "./Constelacion.vue?vue&type=style&index=0&id=f33b6506&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports